import { useStore } from '@tanstack/react-form';
import { useGroupPropertyLabels } from '@/hooks/group/use-group-property-labels';
import FormInputField from '@/components/ui/form-input-field';
import GroupTypeFormSelect from '@/components/group/group-type-form-select';
import GeneralPanelFooter from './general-panel-footer';
import { FormProvider } from '@/contexts/form-context';
import { useUpdateGroupForm } from '@/hooks/group/use-update-group.form';
import { useCurrentGroupQuery } from '@/hooks/group/queries/use-current-group.query';

export default function GeneralPanel() {
  const query = useCurrentGroupQuery();

  const form = useUpdateGroupForm(query.data);

  const groupType = useStore(form.store, (selector) => selector.values.groupType);

  const labels = useGroupPropertyLabels(groupType);

  return (
    <div className="grow">
      <FormProvider form={form}>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            e.stopPropagation();
            form.handleSubmit();
          }}
        >
          <div className="p-6 space-y-6">
            <h2 className="text-2xl font-bold text-gray-800 dark:text-gray-100 mb-5">Allmänt</h2>
            <section>
              <h2 className="text-xl font-bold text-gray-800 dark:text-gray-100 mb-1">Gruppens profil</h2>
              <div className="mt-5 space-y-6 max-w-md">
                <GroupTypeFormSelect name="groupType" label="Typ av grupp" />
                <div className="flex flex-col lg:flex-row gap-6">
                  <FormInputField name="groupName" label={labels.groupName} />
                  <FormInputField name="organizationName" label={labels.organizationName} />
                </div>
              </div>
            </section>
          </div>
          <GeneralPanelFooter />
        </form>
      </FormProvider>
    </div>
  );
}
